export default __webpack_public_path__ + "static/media/38t.a19d4f66.jpg";